import axios from 'axios';

import getAuthSession from './auth';
import { ScreeningCheck, ScreeningRun } from '../interfaces/screening.interface';
import { buildDataGridParams, DataGridQueryParams } from '../utils/adminDashboardUtils';

export async function getScreeningRunsForDataGrid(
  params: DataGridQueryParams,
): Promise<{ results: ScreeningRun[]; count: number }> {
  const authSession = await getAuthSession();

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_API}/qc/screening-runs/`,
    {
      headers: { Authorization: `Bearer ${authSession.getIdToken().getJwtToken()}` },
      params: buildDataGridParams(params),
    },
  );

  return {
    results: response.data.results as ScreeningRun[],
    count: response.data.count,
  };
}

export async function getScreeningRun(runId: number): Promise<ScreeningRun> {
  const authSession = await getAuthSession();

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_API}/qc/screening-runs/${runId}/`,
    {
      headers: { Authorization: `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );

  return response.data as ScreeningRun;
}

export async function respondToScreeningCheck(
  checkId: number,
  adminResponse: 'accepted' | 'dismissed',
): Promise<ScreeningCheck> {
  const authSession = await getAuthSession();
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_API}/qc/screening-checks/${checkId}/response/`,
    { adminResponse },
    {
      headers: { Authorization: `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as ScreeningCheck;
}

export async function rerunScreening(companyCertificationId: number): Promise<void> {
  const authSession = await getAuthSession();
  await axios.post(
    `${process.env.REACT_APP_BASE_API}/qc/screenings/${companyCertificationId}/rerun/`,
    {},
    {
      headers: { Authorization: `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
}
